import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-distribution-withdraw-audit",
  "use": "icon-distribution-withdraw-audit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-distribution-withdraw-audit\"><path d=\"M120.205301 845.919817h783.521644a46.740205 46.740205 0 0 0 44.481095-53.439634l-17.839178-97.920731c-8.880639-40.118676-44.558996-71.200913-84.521872-71.200913H632.244252l-17.761278-111.319589a262.835755 262.835755 0 0 0 164.759224-244.840776 267.198174 267.198174 0 0 0-534.396349 0 262.290453 262.290453 0 0 0 164.759224 244.840776L396.206214 623.358539H182.603476c-40.118676 0-80.159452 31.160137-84.599772 71.200913l-17.839178 97.920731a41.832484 41.832484 0 0 0 40.040775 53.595435zM912.685484 934.882008H111.246762a44.558996 44.558996 0 0 0 0 89.117992H912.685484a44.558996 44.558996 0 0 0 0-89.117992z m0 0\" p-id=\"13906\" fill=\"#BFCBD9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/distribution-withdraw-audit.svg
// module id = lBqP
// module chunks = 59